import { render } from "./AttendanceTrigger.vue?vue&type=template&id=0418b401&scoped=true"
import script from "./AttendanceTrigger.vue?vue&type=script&lang=js"
export * from "./AttendanceTrigger.vue?vue&type=script&lang=js"

import "./AttendanceTrigger.vue?vue&type=style&index=0&id=0418b401&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0418b401"]])

export default __exports__